import axios from "axios";

const API = axios.create({
  baseURL: "https://backend.mhuda.in",
});

export default API;
